import { rewriteWavesalias } from '../products/product-page/data-services/data-service';

/**
 * https://dev.waves.com/mixers-racks/emotion-lv1?wavesalias=video
 */
window.addEventListener('DOMContentLoaded', () => {
    rewriteWavesalias();
});